/* TODO: Rewrite not to use jQuery */
jQuery = window.jQuery;
jQuery( document ).ready(function() {
$("#getzipzonefrm, #getzipzonefrm-copy").submit(function(){
  if( $(this).find("input[type=text], input[type=number]").val().length != 5){
      $("#error").html("Zipcode should contain exactly 5 chars!").show();
      return false;
  }
  var zipcodePattern = /^[0-9]+$/
  if(zipcodePattern.test( $(this).find("input[type=text], input[type=number]").val() ) == false){
      $("#error").html("Zipcode should contain only digits!").show();
      return false;
  }

  $("#error").hide();
  $(this).addClass("loading");

  $.ajax({
      url: "https://apps.edenbrothers.com/getzipzone.php",
      method: "get",
      data: "zipcode=" + $(this).find("input[type=text], input[type=number]").val(),
      success: function(response){
          $("#getzipzonefrm, #getzipzonefrm-copy").removeClass("loading");
          var result = $.parseJSON(response)
          if( result.error ){
              $("#error").html( result.error ).show();
          }else{
              $("#form").hide();
              $("#result").show();
              $("#zipzone").html( result.zipzone )
          }
      }
  })
  //$("#form").hide();
  //$("#result").show();
  //$("#zipzone").html( "8" )
  return false;
});
$("#result a").click(function(){
  $("#zipcode").val("");
  $("#form").show();
  $("#result").hide();
  return false;
});
});